export default __webpack_public_path__ + "static/media/clusterconfiguration_openapi.23df77ff.yaml";